export default __webpack_public_path__ + "static/media/a026-example5.575e93a9.jpg";